export default __webpack_public_path__ + "static/media/10008.7fc84098.png";